var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/location-tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1 42.45C27.95 -0.849988 92.1 -0.799987 101.9 42.5C107.65 67.9 91.85 89.4 78 102.7C67.95 112.4 52.05 112.4 41.95 102.7C28.15 89.4 12.35 67.85 18.1 42.45Z",
    stroke: "#292D32",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.25 57.5L53.75 65L73.75 45",
    stroke: "#292D32",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.3f70b8d4f3c1bc692a5429f69523608c.svg";
export { ForwardRef as ReactComponent };